import type { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";

import { tw } from "@/utils";
import { icons } from "./Icons";

interface ModalProps {
  children?: ReactNode;
  className?: string;
  show: boolean;
  title?: string;
  description?: ReactNode;
  onClose: () => void;
}

export const Modal = ({
  children,
  className,
  show,
  title,
  description,
  onClose,
}: ModalProps) => (
  <Dialog.Root open={show} onOpenChange={onClose}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/20 backdrop-blur-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
      <Dialog.Content
        className={tw(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-sm translate-x-[-50%] translate-y-[-50%] gap-4 border  bg-white p-6 text-base text-gray-800 shadow-xl duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          className,
        )}
      >
        <div className="ml-6 mr-6 mt-6 flex flex-col items-center space-y-1.5 text-center sm:text-left">
          {title && (
            <Dialog.Title className="pb-4 text-center text-2xl font-semibold leading-none tracking-tight">
              {title}
            </Dialog.Title>
          )}

          {description && (
            <Dialog.Content className="text-sm text-gray-500">
              {description}
            </Dialog.Content>
          )}
        </div>

        {children}

        <Dialog.Close asChild>
          <button
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-gray-400 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-gray-800 data-[state=open]:text-gray-50"
            aria-label="Close"
          >
            <icons.XMarkIcon className="h-4 w-4" />

            <span className="sr-only">Close</span>
          </button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
